// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1lFeD","title":"ClientReferral_title__2QRFU","itemText":"ClientReferral_itemText__2zT95"};